import {
	PREDEFINED_USER_ROLES,
	PREDEFINED_ROLE_NAMES,
	ROLE_PERMISSIONS,
} from '../../constants';
import { roleHasPermission } from './rolePermissions';

export const canCompleteAssignedMarketSetups = (user, role = user?.role) => {
	if (!user || user.isSuperAdmin || role?.name === PREDEFINED_USER_ROLES.ADMIN) {
		return false;
	}

	return role?.name === PREDEFINED_USER_ROLES.DRIVER || roleHasPermission({
		role,
		permissionId: ROLE_PERMISSIONS.COMPLETE_ASSIGNED_MARKET_SETUPS,
	});
};

export const isDriver = user => {
	return user && user.role && user.role.name === PREDEFINED_USER_ROLES.DRIVER;
};

export const isTechnician = user => {
	return user && user.role && user.role.name === PREDEFINED_USER_ROLES.TECHNICIAN;
};

export const isPicker = user => {
	return user && user.role && user.role.name === 'Picker';
};

export const isAdmin = user => {
	return user && user.role && user.role.name === PREDEFINED_USER_ROLES.ADMIN;
};

export const calculateIfRoleIsPredefined = roleName => {
	return PREDEFINED_ROLE_NAMES.includes(roleName);
};
